export const MODELO_IMPUESTO = {
  MODELO_111: 111,
  MODELO_115: 115,
  MODELO_180: 180,
  MODELO_190: 190,
  MODELO_303: 303,
  MODELO_347: 347,
  MODELO_349: 349,
  MODELO_390: 390,
} as const

export type ModeloImpuestoType =
  (typeof MODELO_IMPUESTO)[keyof typeof MODELO_IMPUESTO]
